import { createContext } from 'react'

// The condition a node shows under, worded, when a template marks it (set
// from the conditional-display decoration); null otherwise.
export const ObservationNodeCondition = createContext<{
  text: string
  cycle: boolean
} | null>(null)

// The decoration spec the conditional-display plugin puts on a conditional
// node in a template, which the node view reads.
export interface ConditionDecorationSpec {
  conditionText: string
  conditionCycle: boolean
}
